export default __webpack_public_path__ + "static/media/group.9922c8ac.png";